export default class VisitedStatesService {
  constructor($transitions) {
    'ngInject';
    this.transitions = $transitions;
    this.start();
  }

  start() {
    this.visited = {};
    this.registerOnBeforeTo('my-vacations');
  }

  registerOnBeforeTo(stateName) {
    const state = { to: stateName };
    this.transitions.onBefore(state, () => this.setVisited(stateName));
  }

  setVisited(stateName) {
    this.visited[stateName] = true;
  }

  stateVisited(stateName) {
    return this.visited[stateName] === true;
  }
}



// WEBPACK FOOTER //
// ./client/app/common/services/visitedStates.service.js